import SearchHistoryContainer from 'containers/customerAccounts/SearchHistory/index'
import React from 'react'

const SearchHistoryPage = () => {
  return (
    <div><SearchHistoryContainer/></div>
  )
}

export default SearchHistoryPage